module.exports = __webpack_public_path__ + "static/media/1.a84b6553.jpg";